import { CopyButton } from '../../components/CopyButton'
import './ToolInput.css'

/// A section label on an approval card, optionally paired with a copy
/// affordance for the value it introduces.
///
/// Shared by every permission body renderer (ToolInput, EntityCRUDBody,
/// ExternalResourceInvokeBody) so "copy this value" looks and behaves the
/// same wherever it appears. Without it there is no way to lift a command,
/// path, or resource id off an approval card — <body> disables text
/// selection app-wide (styles/global.css) — and going to look a command up
/// before deciding whether to approve it is exactly what these cards are
/// for.
///
/// `copy` is the raw value, which is not always what's rendered: a
/// truncated preview shows an excerpt but copies the whole thing, and the
/// Bash body renders risk-colored segments but copies the original
/// compound command.
export function LabelRow({
  label,
  copy,
  copyLabel,
}: {
  label: string
  copy?: string
  copyLabel?: string
}) {
  return (
    <div className="tool-input__label-row">
      <div className="tool-input__label">{label}</div>
      {copy ? (
        <CopyButton text={copy} ariaLabel={copyLabel ?? `Copy ${label.toLowerCase()}`} />
      ) : null}
    </div>
  )
}
